import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";

import Header from "../header/header";
import Sidebar from "../user/sidebar";
import { saveUser } from "../../redux/user/UserAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const UserDashboard = ({ newUserId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loggeinUser = useSelector((state) => state.user.buyer);
  const [user, setUser] = useState(null);
  const tokenValue = useSelector((state) => state.user.token);
  const uid = useSelector((state) => state.user.uid);
  console.log(tokenValue);
  console.log(loggeinUser);

  useEffect(() => {
    // Define the fetchSingleUser function
    const fetchSingleUser = async () => {
      try {
        const response = await fetch(
          `https://salama-api.onrender.com/users/${uid}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${tokenValue}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          // Check if the response contains a JSON error message from the server
          return response.json().then((errorData) => {
            throw new Error(errorData.error || "Network response was not ok");
          });
        }

        const userData = await response.json();
        console.log(userData);
        setUser(userData);
        dispatch(saveUser(userData));
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    };

    // Call the fetchSingleUser function
    fetchSingleUser();
  }, [
    dispatch,
    tokenValue,
    uid,
  ]); /**added dispatch, tokenValue and uid to dependency array to re-run the effect whenever any of these dependencies change. This ensures that the userEffect always has access to the latest values of these variables and maintains consistency.*/

  return (
    <>
      <Box m="20px" display="flex">
        <Sidebar />

        <Box 
        className="p-8"
          ml="3rem" 
          marginTop={2}
          >
          <Header
            title="Welcome to your Dashboard,"
            subtitle={user?.firstName}
          />

          <Grid 
          
            style={{ display: 'flex', alignItems: 'left', justifyContent: 'center', borderRadius: '10px' }}
            container spacing={3}
            >
            {/* First Row */}
           
              <Box
              className="w-full"
                justifyContent="space-between"
                alignItems="center"
                sx={{ display: { xs: "column", md: "flex" } }}
                p={2}
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{ marginTop: "1rem" }}
                >
                  <Box 
                    className='bg-white h-20 text-center text-blue-600 text-2xl min-w-full' 
                    variant="contained" 
                    color="primary"
                    style={{minWidth: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px' }}
                    >
                    ksh {user?.account.balance}
                  </Box>
                  <h4 className="text-center mt-2">Available Balance</h4>
                </Box>

                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{ marginTop: "1rem" }}
                >
                  <Box 
                    className='bg-white h-20 text-center text-blue-600 text-2xl' 
                    variant="contained" 
                    color="primary"
                    style={{minWidth: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px' }}
                    >
                    ksh {user?.held_fund.amount}
                  </Box>
                  <h4 className="text-center mt-2">Hold Amount</h4>
                </Box>

                <Box
                  onClick={() => navigate("/account")}
                  className='bg-blue-600 cursor-pointer text-center text-white text-2xl min-w-full' 
                  style={{minWidth: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px' }}
                  display="flex"
                  flexDirection="column"
                  sx={{ marginTop: "1rem" }}
                >
                    Deposit              
                </Box>
              </Box>
            

            {/* Second Row */}

              <Box
              className="w-full"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  display: { xs: "column", md: "flex" },
                }} /**responsiveness */
                p={2}
              >
                <Box
                  className='bg-blue-600 cursor-pointer h-20 text-center text-white text-2xl min-w-full' 
                  style={{minWidth: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px' }}
                  variant="contained"
                  color="primary"
                  sx={{ marginTop: "2rem" }}
                  onClick={() => navigate("/new")}
                >
                  New Transactions
                </Box>
                <Box
                  className='bg-blue-600 cursor-pointer h-20 text-center text-white text-2xl min-w-full' 
                  style={{minWidth: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px' }}
                  variant="contained"
                  color="primary"
                  sx={{ marginTop: "2rem" }}
                  onClick={() => navigate("/transactions")}
                >
                  View Transactions
                </Box>
                <Box
                  className='bg-blue-600 cursor-pointer h-20 text-center text-white text-2xl min-w-full' 
                  style={{minWidth: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px' }}
                  variant="contained"
                  color="primary"
                  sx={{ marginTop: "2rem" }}
                  onClick={()=>navigate("/transactions-request")}
                >
                  View Requests
                </Box>
              </Box>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default UserDashboard;
